// extracted by mini-css-extract-plugin
export default {"container":"lRBL6j","noSpacing":"D_HvAG","noSpacingTop":"nQITI_"};